import QRCode from "react-qr-code";

function CustomQRCode(props) {
  const { name = '', permKycId = '', grandFatherName = '', fatherName = '', citizenshipNo = '', issuedDate = '', czDistrict = '' } = props.qrInfo;
  return (
    <QRCode
      style={{ flex: 1, float: "left" }}
      size="130"
      value={`${permKycId}, ${czDistrict}-${citizenshipNo}-${issuedDate}, ${name}, ${fatherName}, ${grandFatherName}`}
    />
  );
}

export default CustomQRCode;
